module.exports = __webpack_public_path__ + "static/media/pricing.19cb9624.png";